const _$ = (id) => document.getElementById(id)
const $ = (sel, wrapper = document) => wrapper.querySelector(sel)
const $$ = (sel, wrapper = document) => wrapper.querySelectorAll(sel)

const getEventTarget = (target, className) => {
  return target.classList.contains(className) ? target : target.closest(`.${className}`)
}

const fetchCasinos = async (page = 1, perPage = 100) => {
  try {
    const response = await fetch(`${SpinokoFrontEnd.restUrl}casino?per_page=${perPage}&page=${page}`) // eslint-disable-line
    const casinos = await response.json()
    return {
      items: casinos,
      totalPages: response.headers.get('x-wp-totalpages'),
    }
  } catch (error) {
    return console.error(error)
  }
}

const fetchGames = async (page = 1, perPage = 100) => {
  try {
    const response = await fetch(`${SpinokoFrontEnd.restUrl}game?per_page=${perPage}&page=${page}`) // eslint-disable-line
    const games = await response.json()
    return {
      items: games,
      totalPages: response.headers.get('x-wp-totalpages'),
    }
  } catch (error) {
    return console.error(error)
  }
}

const debounce = (func, timeout = 300) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

export { _$, $, $$, getEventTarget, fetchCasinos, fetchGames, debounce }
